var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","height":"65vh"}},[_c('div',{staticStyle:{"flex":"1"},attrs:{"id":"user-tree"}})])
}]

export { render, staticRenderFns }